import ko from 'knockout';
import $ from 'jquery';
import _ from 'underscore';
import '@bingads-webui/kendo/kendo.datepicker';

const subscriptionsMap = new Map(); // eslint-disable-line no-undef

const addSubscription = (key, subscription) => {
  const subscriptions = subscriptionsMap.get(key);
  if (subscriptions) {
    subscriptions.push(subscription);
  } else {
    subscriptionsMap.set(key, [subscription]);
  }
};

const dispose = (key) => {
  const subscriptions = subscriptionsMap.get(key);
  if (subscriptions) {
    while (subscriptions.length > 0) {
      subscriptions.pop().dispose();
    }
  }
};

ko.bindingHandlers.datePicker = {
  init: (element, valueAccessor, allBindings) => {
    const value = valueAccessor();
    const bindings = allBindings();
    const { culture, format } = bindings;

    if (!ko.isObservable(value)) {
      throw new Error('Value accessor for date picker should be observable');
    }

    $(element).kendoDatePicker({
      culture,
      format,
      animation: false,
      footer: false,
      value: value(),
      change() {
        let val = this.value();
        if (val == null && !!$(element).val()) {
          val = $(element).val();
        }
        value(val);
      },
    });

    $(element).addClass('form-control');

    const widget = $(element).data('kendoDatePicker');

    if (widget) {
      if (_.isFunction(widget.open)) {
        $(element).click(widget.open.bind(widget));
      }

      if (_.isFunction(widget.value)) {
        const subscription = value.subscribe((newValue) => {
          // eslint-disable-next-line eqeqeq
          if (widget.value() != newValue) { // TODO: originally it was loose comparison
            widget.value(newValue);
          }
        });
        addSubscription(value, subscription);
      }
    }
  },
};

export default { dispose };
